const e = {
  Initiate: "INITIATE",
  Auth: "AUTH",
  Capture: "CAPTURE",
  Cancel: "CANCEL",
  Void: "VOID",
  Skip: "SKIP",
  InitiateRefund: "INITIATE_REFUND",
  Refund: "REFUND",
  RefundStandalone: "REFUND_STANDALONE",
  RefundFollowOn: "REFUND_FOLLOW_ON",
  Tokenize: "TOKENIZE"
};
export {
  e as r
};
//# sourceMappingURL=PaymentEntryType-a687b583.mjs.map
